"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Container = exports.Comment = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Comment = exports.Comment = _styledComponents.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    height: 5px;\n    margin: 5px 0px 15px 0px;\n"])), _ref => {
  let {
    theme: {
      darkGray
    },
    color
  } = _ref;
  return color || darkGray;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size || '11px';
});
const Container = exports.Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    \n    ", "\n"])), (0, _Utils.parseProp)('height'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('marginBottom', 'margin-bottom'), (0, _Utils.parseProp)('marginTop', 'margin-top'), (0, _Utils.parseProp)('order'), (0, _Utils.parseProp)('padding'), (0, _Utils.parseProp)('textAlign', 'text-align'), (0, _Utils.parseProp)('width'), (0, _Utils.ifProp)('noPrint', "\n        @media print {\n            display: none;\n        }\n    "));
const Label = exports.Label = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    align-items: center;\n    color: ", ";\n    ", "\n    display: flex;\n    flex-direction: row;\n    font-size: ", ";\n    font-weight: 500;\n    margin: 0px;\n    ", "\n"])), _ref3 => {
  let {
    theme: {
      labelColor
    },
    color
  } = _ref3;
  return color || labelColor;
}, (0, _Utils.ifProp)('collapse', 'cursor: pointer;'), _ref4 => {
  let {
    size
  } = _ref4;
  return size !== null && size !== void 0 ? size : '12px';
}, (0, _Utils.parseProp)('labelMarginBottom', 'margin-bottom'));